<mat-card appearance="outlined" class="mat-card-fix">
    <form class="fix-editor">
        <se-autocomplete
            [items]="items()"
            [value]="getValue()"
            [required]="isRequired()"
            [isWithLabel]="false"
            (valueChange)="updateValue($event)"
            (optionsClickedEvent)="optionClicked($event)"
            [focusSelectOn]="cellReady()"
        >
        </se-autocomplete>
    </form>
</mat-card>
